import { HeaderSimple } from './HeaderSimple'
import { HeaderCustomer } from './HeaderCustomer'

export const Header = {
  Simple: HeaderSimple,
  Customer: HeaderCustomer
}
